import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 27 27">
    <title>Close</title>
    <path
      d="M20 7L7 20M7 7L20 20"
      stroke="white"
      strokeWidth="2.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default Icon;
